export const videos = [

  {
    id: 7,
    title: "EDUFAM",
    thumbnail: "/thumbnails/Edufam.png",
    category: "Music",
    videoUrl: "https://www.youtube.com/embed/bD3_kUbyKAY?start=65"
  },
   {
    id: 8,
    title: "EU Documentary",
    thumbnail: "/thumbnails/European Union.png",
    category: "Music",
    videoUrl: "https://www.dailymotion.com/embed/video/kkGgLWIVlqrGEQDenUE"
  },
  {
    id: 14,
    title: "BPR",
    thumbnail: "/thumbnails/BPR.png",
    category: "Music",
    videoUrl: "https://www.dailymotion.com/embed/video/x9txte6"
  },
  {
    id: 13,
    title: "Agroforestry",
    thumbnail: "/thumbnails/FORESTRY.JPG",
    category: "Music",
    videoUrl: "https://www.dailymotion.com/embed/video/x9txx6k"
  },
  
  {
    id: 1,
    title: "PRIMUS",
    thumbnail: "/thumbnails/Primus.png",
    category: "Documentaries",
    videoUrl: "https://www.dailymotion.com/embed/video/kUv6CQvQSBYEzQDdIia"
  },
  {
    id: 4,
    title: "Africa Haguruka 25 Jubilee Celebration",
    thumbnail: "/thumbnails/Africa Haguruka.png",
    category: "Documentaries",
    videoUrl: "https://www.dailymotion.com/embed/video/k7eZnW0C569m8MDdIos"
  },
  {
    id: 9,
    title: "Inyambo Travel",
    thumbnail: "/thumbnails/Inyambo.png",
    category: "Music",
    videoUrl: "https://www.dailymotion.com/embed/video/x9qe7yu"
  },
  {
    id: 2,
    title: "Africa Energy Expo Day 1",
    thumbnail: "/thumbnails/AEE 1.png",
    category: "Documentaries",
    videoUrl: "https://www.dailymotion.com/embed/video/k6MiBedKH8lU2JDdKpc"
  },
  
  {
    id: 5,
    title: "Women's Initiative International",
    thumbnail: "/thumbnails/WomenInitiative.jpg",
    category: "Documentaries",
    videoUrl: "https://www.dailymotion.com/embed/video/x9qe8s8"
  },
   {
    id: 10,
    title: "Micro Reportage",
    thumbnail: "/thumbnails/Dina.png",
    category: "Music",
    videoUrl: "https://www.dailymotion.com/embed/video/k6oAV8dijVTZ35DdLLI"
  },
   {
    id: 11,
    title: "Radiant Building Inauguration",
    thumbnail: "/thumbnails/Radiant.png",
    category: "Music",
    videoUrl: "https://www.dailymotion.com/embed/video/kp0XWEnG10fGWtDdLwG"
  },
  {
    id: 12,
    title: "UNICEF",
    thumbnail: "/thumbnails/Unicef 3.png",
    category: "Music",
    videoUrl: "https://www.dailymotion.com/embed/video/k1sHp5I48kO2wzDdM1e"
  },
  {
    id: 6,
    title: "BK Techouse",
    thumbnail: "/thumbnails/BkTechouse.png",
    category: "Music",
    videoUrl: "https://www.dailymotion.com/embed/video/k8oVlaTwotZMBJDdM9s"
  }
 
  
  
]; 
